<template>
  <v-app>
    <page-header>
      <span slot="header-title">{{ $t("GENERAL_INFO") }}</span>
    </page-header>
    <left-menu />
    <div class="main-content right-page-content">
      <div class="content">
        <div class="ex-card">
          <span class="ex-card__title">{{ $t("CONTACT_BOOKING_DETAIL") }}</span>
          <div class="ex-card__content">
            <v-row>
              <v-col sm="6" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Người đặt</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">Phạm Hoàng Hải</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Số điện thoại</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">035 7206 028</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col sm="6" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Email</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">hai.pham@gmail.com</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Đại lý</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">Sai Gon Tourist</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="ex-card">
          <span class="ex-card__title">{{ $t("BOOKING_DETAIL") }}</span>
          <div class="ex-card__content">
            <v-row>
              <v-col sm="6" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Mã đặt phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value -green -bold">312328394</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Trạng thái đặt phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value -green -bold">Đã thanh toán</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày đặt</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">20/03/2019 14:12</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col sm="6" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày nhận phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">05/04/2019</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày trả phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">06/04/2019</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày cập nhật</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">20/03/2019 14:12</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="ex-card">
          <span class="ex-card__title">{{ $t("NORMAL_ROOM_DETAIL") }}</span>
          <div class="ex-card__content">
            <v-row>
              <v-col sm="2" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Mã đặt phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value -green -bold">312328394</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Trạng thái đặt phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value -green -bold">Đã thanh toán</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày đặt</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">20/03/2019 14:12</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col sm="6" class="py-0">
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày nhận phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">05/04/2019</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày trả phòng</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">06/04/2019</span>
                    </v-col>
                  </v-row>
                </div>
                <div class="_item">
                  <v-row>
                    <v-col sm="5" class="py-0">
                      <span class="_name">Ngày cập nhật</span>
                    </v-col>
                    <v-col sm="7" class="py-0">
                      <span class="_value">20/03/2019 14:12</span>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import PageHeader from "@/components/Utils/Header.vue";
import LeftMenu from "@/components/Utils/LeftMenu.vue";
export default {
  components: {
    "page-header": PageHeader,
    "left-menu": LeftMenu
  },
  prop: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {}
};
</script>
